module.exports = __webpack_public_path__ + "bd03a2cc277bbbc338d464e679fe9942.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Regular.woff2
// module id = 986
// module chunks = 0